export default __webpack_public_path__ + "static/media/OpenSans-LightItalic.0ce71e4f.ttf";